import { useEffect, useState } from "react";

import StateSchoolType from "../auth/login/StateSchoolType";

import Modal from "../../modal/Modal";

import { encrypt } from "../../encryption/Encryption";

import { getTeacherDetails } from "../auth/GsrtUserRegistration/SoapApiGetTeacherDetail";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";

import {
  getTranslatedText,
  getTranslatedTextSelector,
} from "../../../redux/slices/translatedText/getTranslatedText";
import TeacherIdProfileCard from "../teacherIdProfile";
import {
  getSchoolByUDISE,
  updateProfile,
} from "../../../redux/slices/profile/profileSlice";
import axios from "axios";
import {
  getMeghalayaTeacherDetails,
  verifyTeacherIdGcsess,
} from "../auth/GsrtUserRegistration/ApiGetTeacherDetail";

const TeacherProfileCardId = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [pageRender, setPageRender] = useState(0);

  const [selectedState, setSelectedState] = useState(null);
  const [selectedBoard, setSelectedBoard] = useState(null);

  const [teacherId, setTeacherId] = useState(null);
  const [teacherData, setTeacherData] = useState(null);
  const [teacherModalId, setTeacherModalId] = useState(false);
  const [teacherIdLoading, setTeacherIdLoading] = useState(false);

  const getTextTranslated = useSelector(getTranslatedTextSelector);

  useEffect(() => {
    getText();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getText = async () => {
    await dispatch(getTranslatedText(localStorage.getItem("l_id"))).unwrap();
  };

  const handleProceedButton = () => {
    if (
      (selectedState?.label === "GUJARAT" &&
        selectedBoard?.label ===
          "GCSE-SS (Gujarat Council of School Education Samagra Shiksha)") ||
      (selectedState?.label === "MEGHALAYA" &&
        selectedBoard?.label ===
          "SEMAM(State Education Mission Authority of Meghalaya)")
    ) {
      setTeacherModalId(true);
    } else {
      navigate("/user/profile");
    }
  };

  const handleTeacherId = (e) => {
    const value = e.target.value;

    if (selectedState?.label === "MEGHALAYA") {
      // Allow typing: up to 2 letters followed by digits
      if (/^[A-Za-z]{0,2}\d*$/.test(value)) {
        setTeacherId(value.toUpperCase());
      }
    } else {
      // Gujarat and others: only digits
      if (/^\d*$/.test(value)) {
        setTeacherId(value);
      }
    }
  };
  const handleTeacherIdCancel = () => {
    setTeacherModalId(false);
  };

  const isTeacherIdButtonEnabled = teacherId?.length >= 6;

  const handleContinue = async () => {
    try {
      setTeacherIdLoading(true);

      const verifyResponse = await verifyTeacherIdGcsess(teacherId);

      if (verifyResponse?.data?.status === 1) {
        toast.error("This teacher ID already exists.");
        return;
      }

      let teacherData;

      if (selectedState?.label?.toUpperCase() === "MEGHALAYA") {
        const response = await getMeghalayaTeacherDetails(teacherId);

        const teacher = response?.data?.response?.[0];

        console.log(teacher, "Meghalya api");

        if (!teacher) {
          throw new Error("Teacher not found");
        }

        teacherData = [
          {
            TeacherID: teacher.teacherId,
            TeacherName: `${teacher.firstName} ${teacher.lastname}`,
            DOB: teacher.dob,
            GENDER: teacher.gender,
            MobileNumber: "",
            WhatsappNumber: teacher.whatsappNo,
            EmailId: teacher.emailId,
            School_UDISE: teacher.udiseCode,
            SCHNAME: teacher.schoolName,
            State: teacher.stateName,
            District: teacher.districtName,
            Block_Zone: teacher.blockName,
            ClusterName: "",
          },
        ];
      } else {
        const response = await getTeacherDetails("SSAIED", teacherId);

        teacherData = response?.data?.response;
      }

      if (teacherData) {
        setTeacherData(teacherData);
        setTeacherModalId(false);
        // setPageRender(1);
      } else {
        setTeacherData(null);

        toast.error(
          getTranslatedText?.data?.find(
            (item) => item?.pageKey === "data_not_found",
          )?.keyValue || "Data not found",
        );
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setTeacherIdLoading(false);
    }
  };

  useEffect(() => {
    if (teacherData) {
      setPageRender(1);
    }
  }, [teacherData]);

  const genderMap = {
    male: 1,
    female: 2,
    other: 3,
  };

  const formatMeghalayaDOB = (dob) => {
    if (!dob) return "";

    const [day, month, year] = dob.split("-");
    return `${year}-${month}-${day}`;
  };

  const handleConfirmTeacherDetail = async () => {
    const udiseCode = teacherData?.[0]?.School_UDISE;
    const userId = JSON.parse(localStorage.getItem("id")).toString();

    try {
      const response = await dispatch(
        getSchoolByUDISE({
          UdiseCode: udiseCode,
        }),
      ).unwrap();

      const { response: dataResponse } = response || {};

      if (response?.status === 1) {
        const isMeghalaya = selectedState?.label?.toUpperCase() === "MEGHALAYA";
        const DateOfBirth =
          selectedState?.label?.toUpperCase() === "MEGHALAYA"
            ? formatMeghalayaDOB(teacherData?.[0]?.DOB)
            : teacherData?.[0]?.DOB;

        const formData = {
          UserId: userId,
          FirstName: teacherData?.[0]?.TeacherName?.split(" ")[0] || "",
          LastName:
            teacherData?.[0]?.TeacherName?.split(" ").slice(1).join(" ") || "",

          MobileNo: isMeghalaya
            ? encrypt(teacherData?.[0]?.WhatsappNumber)
            : encrypt(teacherData?.[0]?.MobileNumber) || 0,

          WhatsAppNo: encrypt(teacherData?.[0]?.WhatsappNumber),

          EmailId: teacherData?.[0]?.EmailId || "",
          Gender: genderMap[teacherData?.[0]?.GENDER?.toLowerCase()] || 0,
          DOB: encrypt(DateOfBirth),
          schoolUdise: teacherData?.[0]?.School_UDISE || 0,
          SchoolName: teacherData?.[0]?.SCHNAME || "",
          SchoolId: dataResponse?.[0]?.schoolId || "",
          StateId: dataResponse?.[0]?.stateId || "",
          DistrictId: dataResponse?.[0]?.districtId || "",
          BlockId: dataResponse?.[0]?.blockId || "",
          clusterName: teacherData?.[0]?.ClusterName || "",
          teacherId: teacherData?.[0]?.TeacherID || null,
          QualificationId: 0,
          ProfessionId: 0,
          SpecializationId: 0,
          CRRNum: "0",
          ReasonId: "0",
          InstitutionName: "0",
        };

        dispatch(updateProfile(formData))
          .unwrap()
          .then((resp) => {
            console.log("Profile Updated", resp);

            if (resp?.status === 1) {
              const getUser = JSON.parse(localStorage.getItem("user")) || {};

              const data = resp?.response?.[0];

              const updatedUser = {
                ...getUser,
                id: data.id,
                firstName: data.firstName,
                lastName: data.lastName,
                teacherId: teacherData?.[0]?.TeacherID || null,
                mobileNo: data.mobileNo,
                whatsAppNo: data.whatsAppNo,
                emailId: data.emailId,
                gender: data.gender,
                dob: data.dob,
                schoolId: data.schoolId,
                schoolName: data.schoolName,
                stateId: data.stateId,
                districtId: data.districtId,
                blockId: data.blockId,
                qualificationId: data.qualificationId,
                professionalId: data.professionalId,
                specializationId: data.specializationId,
                crrNum: data.crrNum,
                reasonId: data.reasonId,
                institutionName: data.institutionName,
                profilePicURL: data.profilePicURL,
                schoolTypeId: data.schoolTypeId,
              };
              localStorage.setItem("user", JSON.stringify(updatedUser));
              toast.success("Profile updated successfully");

              navigate("/user/dashboard", {
                state: { isProfileCompleted: true },
              });
            } else {
              toast.warning("Some Error Occurred");
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error("Profile update failed");
          });
      } else {
        console.log("School not found");
      }
    } catch (error) {
      console.error("Verification API Error:", error);
    }
  };

  const handleCancelTeacherDetail = () => {
    setPageRender(0);
  };

  return (
    <>
      {pageRender === 0 ? (
        <StateSchoolType
          selectedBoard={selectedBoard}
          selectedState={selectedState}
          setSelectedBoard={setSelectedBoard}
          setSelectedState={setSelectedState}
          handleProceedButton={handleProceedButton}
        />
      ) : (
        <TeacherIdProfileCard
          teacherData={teacherData}
          handleCancelTeacherDetail={handleCancelTeacherDetail}
          handleConfirmTeacherDetail={handleConfirmTeacherDetail}
        />
      )}

      {teacherModalId && (
        <Modal visible={teacherModalId}>
          <div className=" w-16/16 m-auto mx-[15px] ">
            <div className=""></div>
            <div className="bg-[#fff] px-6 py-6 rounded-[12px] flex flex-col justify-center items-center">
              <h5 className="font-semibold text-[18px] my-2">Teacher ID</h5>
              <div className="relative bg-[#F6F7FA] py-2 px-3 pr-10 my-2 border border-[#F6F7FA] rounded-md">
                <input
                  id="teacherId"
                  name="teacherId"
                  className="bg-[#F6F7FA] !outline-none"
                  placeholder="Enter Teacher ID"
                  value={teacherId}
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  onChange={(e) => {
                    handleTeacherId(e);
                  }}
                />
              </div>

              <div className="flex justify-around w-[100%] gap-4">
                <button
                  className="bg-gradient-to-r from-[#E7EAFF] to-[#E7EAFF] text-[#3C57AD] px-[40px] py-[10px] rounded-[10px] mt-[20px] text-center flex flex-row justify-center"
                  onClick={() => handleTeacherIdCancel()}
                >
                  Cancel
                </button>
                <button
                  onClick={handleContinue}
                  disabled={teacherIdLoading || !isTeacherIdButtonEnabled}
                  className={`relative px-[40px] py-[10px] rounded-[10px] mt-[20px] text-center flex flex-row justify-center items-center ${
                    teacherIdLoading
                      ? "bg-[#3a3e58] text-[#fff] cursor-wait"
                      : isTeacherIdButtonEnabled
                        ? "bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-white cursor-pointer"
                        : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
                >
                  {teacherIdLoading ? (
                    <>
                      <div className="flex items-center space-x-2">
                        <div className="spinner-border animate-spin inline-block w-4 h-4 border-4 rounded-full"></div>
                        <span>
                          {getTextTranslated?.data?.length > 0
                            ? getTextTranslated?.data?.filter(
                                (item) => item.pageKey === "label_loading",
                              )[0].keyValue
                            : "Loading"}
                          {""}
                          ...
                        </span>
                      </div>
                    </>
                  ) : getTextTranslated?.data?.length > 0 ? (
                    getTextTranslated?.data?.filter(
                      (item) => item.pageKey === "btn_proceed",
                    )[0].keyValue
                  ) : (
                    "Proceed"
                  )}
                  {/* <ReactIcons.AiFillRightCircle className="absolute right-3 top-[13px] text-[#586084] text-xl" /> */}
                  <span className="bg-[#586084] p-[8px] rounded-[100%] absolute right-3 top-[12px] md:top-[8px]">
                    <img
                      src="../right-arrow.png"
                      className="w-[8px] h-[10px]"
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <ToastContainer />
    </>
  );
};
export default TeacherProfileCardId;
